<script setup lang="ts">
import PermissionLevel from '@/assets/js/enum/PermissionLevel';

interface Props {
  show: boolean;
  permissionLevel?: string;
}

defineProps<Props>();
</script>

<template>
  <div
    v-if="permissionLevel === PermissionLevel.COHORT && show"
    ref="alertBox"
    class="uk-position-fixed uk-flex uk-width-1-1 uk-flex uk-flex-center"
    style="top: 17%; z-index: 9999"
  >
    <div
      class="uk-flex uk-flex-center uk-flex-middle uk-border-rounded uk-box-shadow-large uk-width-1-3"
      style="padding: 10px; background-color: white"
    >
      <div uk-alert class="uk-alert-warning uk-flex alert-box" style="align-items: baseline">
        <i uk-icon="warning" style="min-width: 1rem"></i>
        <span class="uk-margin-small-left uk-text-secondary uk-text-small"
          >You have 10 minutes remaining. Please finish your annotations and submit them</span
        >
      </div>
    </div>
  </div>
</template>
